import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import useApi, { LoadError } from "@/lib/useApi";
import useSEO from "@/hooks/useSEO";
import { PageHero, VideoRow, VideoCard, Empty } from "@/components/ui-lux";

export default function Videos() {
  const [params, setParams] = useSearchParams();
  const vRes = useApi("/content/videos");
  const cRes = useApi("/content/categories");
  const videos = useMemo(() => vRes.data || [], [vRes.data]);
  const cats = cRes.data || [];
  const [q, setQ] = useState("");
  const active = params.get("category") || "";
  useSEO({ title: "Free Discipleship Videos", description: "Teachings, videos and masterclasses on renewing your mind, faith and purpose." });
  const failed = vRes.error || cRes.error;
  const filtered = useMemo(() => {
    const s = q.toLowerCase();
    return videos.filter((v) => (!active || v.category === active) && (!s || `${v.title} ${v.description} ${v.category}`.toLowerCase().includes(s)));
  }, [videos, q, active]);
  const grid = q || active;
  return (
    <div data-testid="videos-page">
      <PageHero eyebrow="Free Discipleship Videos" title="Teachings that renew your mind." sub="Search the full library of teachings, series and masterclasses." image="/images/todd-4691.jpg">
        <div className="mt-10 relative max-w-xl">
          <Search className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search teachings..." className="field !rounded-full !pl-12 !py-4 !bg-white/10 !border-white/20" data-testid="video-search-input" aria-label="Search teachings" />
        </div>
      </PageHero>
      <div className="container-x">
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-10" role="tablist">
          {["", ...cats.map((c) => c.name)].map((c) => (
            <button key={c || "all"} onClick={() => setParams(c ? { category: c } : {})} className={`shrink-0 px-4 py-2 rounded-full text-sm border transition-colors ${active === c ? "bg-white text-black border-white" : "border-white/20 text-slate-300 hover:border-white"}`} data-testid={`category-filter-${c ? c.toLowerCase().replace(/\s+/g, "-") : "all"}`}>{c || "All"}</button>
          ))}
        </div>
        {failed ? <LoadError onRetry={() => { vRes.reload(); cRes.reload(); }} /> : grid ? (
          filtered.length ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="video-grid">{filtered.map((v) => <VideoCard key={v.id} v={v} wide />)}</div>
          ) : <Empty text="No teachings match your search." />
        ) : (
          cats.map((c) => <VideoRow key={c.id} title={c.name} videos={videos.filter((v) => v.category === c.name)} testid={`video-row-${c.slug}`} />)
        )}
      </div>
    </div>
  );
}
